import { httpClientService } from "src/app/services/httpClientService";
import { environment } from "../../environments/environment";

import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, tap, retry } from "rxjs/operators";

import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class LoginControllerApi {
  [x: string]: any;
  constructor(private http: httpClientService) {}

  gateWayName = {
    registration: "registration",
    login: "login",
    adminservice: "adminservice",
  };
  API = {
   

    // login: environment.prefix + this.gateWayName.login + "/v1/login",
    // loginOTP: environment.prefix + this.gateWayName.login + "/customer/v1/otp",
    // loginWithOTP:
    //   environment.prefix +
    //   this.gateWayName.registration +
    //   "/customer/v1/valid/otp",

    //Admin login
    LoginWithOTP: environment.prefix + "adminlogin/login",

    Login: environment.prefix + "login/v1/login",


    onForget: environment.prefix + "registration/forget-password/otp",

    onLoggedin:
      environment.prefix + "registration/forget-password/otp/validate",

    onConfirmPassword:
      environment.prefix + "registration/forget-password/reset-password",

      ChangePassword:
      environment.prefix + "registration/forget-password/change-password",

      logout: environment.prefix + 'login/customer/v1/logout',
      TermsAndConditions:environment.prefix +'cms/message-codes/message/MAIN_TERMS_CONDITION'


    };

 

  public LoginWithOTP(body: any) {
    return this.http.post(this.API.LoginWithOTP, body);
  }

  public Login(body: any) {
    return this.http.post(this.API.Login, body);
  }

 

  public logout(body:any) {
    return this.http.post(this.API.logout, body);
  }


  public openTermsAndConditions(){
    return this.http.get(this.API.TermsAndConditions )
  }
  

  public onLoggedin(body: any) {
    return this.http.post(this.API.onLoggedin, body);
  }

  
  public onForget(body: any) {
   return this.http.post(this.API.onForget, body);
  }
  




  public onConfirmPassword(body: any) {
  return this.http.put(this.API.onConfirmPassword, body);
  }

  public ChangePassword(body: any) {
    return this.http.put(this.API.ChangePassword, body);
  }


 


}
